var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-form"},[_c('span',{staticClass:"alert-warning"},[_vm._v("Erro!")]),_vm._v(" "),_c('p',[_vm._v("Sua solicitação não foi enviada. Clique abaixo para tentar novamente.")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"id":"btn-return-form"},on:{"click":_vm.returnToForm}},[_vm._v("Voltar")])])
}
var staticRenderFns = []

export { render, staticRenderFns }